<template>
  <div class="software_module">
    <div>
      <el-row :gutter='33'>
        <el-col :span="8" v-for="(product,index) in softwareArr" :key="index">
          <el-card class="pro_cup">
            <div class="img_cup">
              <img :src="product.picMain" alt="" width="98%" height="280">
            </div>
            <div class="pro_title">{{product.proTitle}} </div>
            <div>
              <img :src="btnImg" alt="" width="60%" height="45">
            </div>
            <div class="btn_word" @click="viewSoftware(product.proId)">Check the details</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { productList } from '@/api/enFrontApi/product';
export default {
  data() {
    return {
      softwareArr: [],
      btnImg: '../../../../static/img/product/button_product.jpg'
    };
  },
  created() {
    this.softwareList();
  },
  methods: {
    softwareList() {
      // proType 1软件
      productList(1).then(res => {
        if (res.data.length > 0) {
          this.softwareArr = [];
          this.softwareArr = res.data;
        }
      });
    },
    viewSoftware(softwareId) {
      this.$router.push({
        name: 'iaic2019en/productInfo',
        params: {
          productId: softwareId
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.define_module {
  width: 100%;
  background-color: #fff;
  text-align: center;
}

.pro_cup {
  cursor: pointer;
  padding: 10px 10px 20px;
  margin-bottom: 33px;
  text-align: center;

  .pro_title {
    margin: 15px 0;
    font-size: 18px;
  }

  .pro_title:hover {
    color: #006A80;
  }

  .pro_btn {
    border: 1px solid red;
    width: 180px;
    height: 80px;
    border: none;
    background-image: url('../../../../static/img/product/button_product.jpg');
    color: #fff;
  }

  .btn_word {
    margin-top: -37px;
    margin-left: -60px;
    color: #fff;
  }
}

.pro_cup:hover {
  box-shadow: 10px 10px 5px #888888;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/product/softwareObj.vue